import React from "react";

const ReportFilterSummary = ({
  selectedBranches,
  selectedDepartments,
  selectedCourses,
  selectedPlacedBy,
  packageRange,
  placementDateFrom,
  placementDateTo,
  placementStatusFilter,
  selectedLocations,
  setSelectedLocations,

  setSelectedBranches,
  setSelectedDepartments,
  setSelectedCourses,
  setSelectedPlacedBy,
  setPackageRange,
  setPlacementDateFrom,
  setPlacementDateTo,
  setPlacementStatusFilter
}) => {

  const hasFilters =
    selectedLocations.length > 0 ||
    selectedBranches.length > 0 ||
    selectedDepartments.length > 0 ||
    selectedCourses.length > 0 ||
    selectedPlacedBy.length > 0 ||
    packageRange ||
    placementDateFrom ||
    placementDateTo ||
    placementStatusFilter !== "All"
  if (!hasFilters) return null;

  const removeItem = (list, setList, value) => {
    setList(list.filter(item => item !== value));
  };

  const clearAll = () => {
    setSelectedBranches([]);
    setSelectedDepartments([]);
    setSelectedCourses([]);
    setSelectedPlacedBy([]);
    setPackageRange("");
    setPlacementDateFrom("");
    setPlacementDateTo("");
    setPlacementStatusFilter("All");
  };

  return (
    <div className="filter-summary-row">
      <div className="active-filters-summary">
        <span className="filters-label">Active Filters:</span>

        {/* Location */}
        {selectedLocations.map((loc, i) => (
          <span key={i} className="filter-badge location">
            {loc}
            <button
              className="clear-filter-btn"
              onClick={() =>
                removeItem(
                  selectedLocations,
                  setSelectedLocations,
                  loc
                )
              }
            >
              ×
            </button>
          </span>
        ))}

        {/* Branch */}
        {selectedBranches.map((b, i) => (
          <span key={i} className="filter-badge branch">
            {b}
            <button
              className="clear-filter-btn"
              onClick={() => removeItem(selectedBranches, setSelectedBranches, b)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Department */}
        {selectedDepartments.map((d, i) => (
          <span key={i} className="filter-badge department">
            {d}
            <button
              className="clear-filter-btn"
              onClick={() => removeItem(selectedDepartments, setSelectedDepartments, d)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Course */}
        {selectedCourses.map((c, i) => (
          <span key={i} className="filter-badge course">
            {c}
            <button
              className="clear-filter-btn"
              onClick={() => removeItem(selectedCourses, setSelectedCourses, c)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Placed By */}
        {selectedPlacedBy.map((p, i) => (
          <span key={i} className="filter-badge placedby">
            {p}
            <button
              className="clear-filter-btn"
              onClick={() => removeItem(selectedPlacedBy, setSelectedPlacedBy, p)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Package */}
        {packageRange && (
          <span className="filter-badge package">
            Package: {packageRange}
            <button
              className="clear-filter-btn"
              onClick={() => setPackageRange("")}
            >
              ×
            </button>
          </span>
        )}

        {/* Date From */}
        {placementDateFrom && (
          <span className="filter-badge date">
            From: {placementDateFrom}
            <button
              className="clear-filter-btn"
              onClick={() => setPlacementDateFrom("")}
            >
              ×
            </button>
          </span>
        )}

        {/* Date To */}
        {placementDateTo && (
          <span className="filter-badge date">
            To: {placementDateTo}
            <button
              className="clear-filter-btn"
              onClick={() => setPlacementDateTo("")}
            >
              ×
            </button>
          </span>
        )}

        {/* Status */}
        {/* Status */}
        {placementStatusFilter !== "All" && (
          <span className="filter-badge status">
            Status: {placementStatusFilter}
            <button
              className="clear-filter-btn"
              onClick={() => setPlacementStatusFilter("All")}
            >
              ×
            </button>
          </span>
        )}

        <button className="clear-all-btn" onClick={clearAll}>
          Clear All
        </button>
      </div>
    </div>
  );
};

export default ReportFilterSummary;